import { Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../App.css"; /* Importing the global CSS file */
import App from "../App";
import ProtectedRoute from "../components/ProtectedRoute";
import TempProtectedRoute from "../components/TempProtectedRoute";
import AdminDashboard from "../components/Admin/AdminDashboard";
import AdminLayout from "../components/Admin/AdminLayout";
import AdminUsers from "../components/Admin/AdminUsers";
import AddUser from "../components/Admin/AddUser";
import EditUser from "../components/Admin/EditUser";
import AdminRoles from "../components/Admin/AdminRoles";
import AdminSettings from "../components/Admin/AdminSettings";
import AdminLogs from "../components/Admin/AdminLogs";
import UnifiedAuditLogs from "../components/Admin/UnifiedAuditLogs";
import SectorIndustryClassificationManagement from "../components/Admin/SectorIndustryClassificationManagement";
// import ShareholdingPatternManagement from "../components/Admin/ShareholdingPatternManagement";
import IssuerEsgRatingsManagement from "../components/Admin/IssuerEsgRatingsManagement";
import DataFetching from "../components/Admin/DataFetching";
import NewsManagement from "../components/Admin/NewsManagement";
import MarketData from "../components/Admin/MarketData";
import FinancialData from "../components/Admin/FinancialData";
import GovernmentNSDL from "../components/Admin/GovernmentNSDL";
import SCANData from "../components/Admin/SCANData";
import IssuerFinancialReportsAdmin from "../components/Admin/IssuerFinancialReportsAdmin";
import IssuerBorrowingAdmin from "../components/Admin/IssuerBorrowingAdmin";
import BondCashflowAdmin from "../components/Admin/BondCashflowAdmin";
import TermsheetAdmin from "../components/Admin/TermsheetAdmin";
import TermsheetEditAdmin from "../components/Admin/TermsheetEditAdmin";
import IssuerCategory from "../components/LandingPagesRedesign/IssuerCategoryRedesign";
import IssuerCategorization from "../components/LandingPagesRedesign/IssuerCategorizationRedesign";

import PricingPage from "../components/Pricing/PricingPage";
import AdminApprovalComponent from "../components/Admin/AdminApprovalComponent";
import NewsApproval from "../components/Admin/NewsAprroval";
import AdminPayments from "../components/Admin/AdminPayments";
import AdminOrders from "../components/Admin/AdminOrders";
import AdminSubscriptions from "../components/Admin/AdminSubscriptions";
import AdminPlans from "../components/Admin/AdminPlans";
import GovernmentSchemesDashboard from "../components/Government-Schemes/RBIStateGovSecurities";
import RBIGovSecurities from "../components/Government-Schemes/RBIGovSecurities";
import RBIStateGovSecurities from "../components/Government-Schemes/RBIStateGovSecurities";
import Profile from "../components/Profile";
import CorporateInventory from "../components/nsdl/CorporateInventory";
import NSDLHome from "../components/nsdl/NSDLHome";
import PreferenceShares from "../components/nsdl/PreferenceShares";
import CommercialPapersInventory from "../components/nsdl/CommercialPapersInventory";
import DefaultedInRedemption from "../components/nsdl/DefaultedInRedemption";
import Sec from "../components/nsdl/sec";
import GovStateSecYeild from "../components/yeild/GovStateSecYeild";
import CorporateYeild from "../components/yeild/CorporateYeild";
import GovSecYeild from "../components/yeild/GoveSecYeild";
import ConditionalDashboard from "../components/Dashboard/ConditionalDashboard";
import ModernLogin from "../components/ModernLogin";
import VerifyOTP from "../components/VerifyOTP";
import SignUpModern from "../components/SignUpModern";
import ForgotPassword from "../components/ForgotPassword";
import ResetPassword from "../components/ResetPassword";
import ChangePassword from "../components/ChangePassword";
import TwoFactorAuth from "../components/TwoFactorAuth";
import IssuerList from "../components/IssuerList/IssuerList";
import ConditionalIssuerRoute from "../components/ConditionalRoutes/ConditionalIssuerRoute";
import ConditionalInstrumentsRoute from "../components/ConditionalRoutes/ConditionalInstrumentsRoute";
import ConditionalIssuerDetailsRoute from "../components/ConditionalRoutes/ConditionalIssuerDetailsRoute";
import ISINDetails from "../components/IssuerDetails/ISINDetails";
import ConditionalInstrumentDetailsRoute from "../components/ConditionalRoutes/ConditionalInstrumentDetailsRoute";
import ConditionalFinancialDetailsRoute from "../components/ConditionalRoutes/ConditionalFinancialDetailsRoute";
import IssuerFinancialsPage from "../components/LandingPages/BankingFinancials";
import CreditRisk from "../components/Admin/CreditRisk";

import News from "../components/News";
// import News from "../components/News";
import IssuerDetails from "../components/IssuerDetails/IssuerDetails";
import IssuerISINs from "../components/IssuerDetails/IssuerISINs";
import IssuerRatings from "../components/IssuerDetails/IssuerRatings";

import IssuerNews from "../components/IssuerDetails/IssuerNews";
import CertificatesOfDeposit from "../components/nsdl/CertificatesOfDeposit";
import TwoFactorLogin from "../components/TwoFactorLogin";
import HomePage from "../components/LandingPagesRedesign/HomePageRedesign";
import LandingPage from "../components/LandingPagesRedesign/LandingPageRedesign";
import LandingLayout from "../components/LandingPagesRedesign/LandingLayoutRedesign";
import LoginPage from "../components/LandingPages/LoginPage";
import IssuerCategoryRedesign from "../components/LandingPagesRedesign/IssuerCategoryRedesign";
import IssuerCategorizationRedesign from "../components/LandingPagesRedesign/IssuerCategorizationRedesign";
import Issuers from "../components/LandingPages/Issuers";
import LandingInstruments from "../components/LandingPages/Instruments";
import ExternalIssuerDetails from "../components/LandingPages/IssuerDetails";
import IssuerRatingsDetails from "../components/LandingPages/IssuerRatingsDetails";
import IssuerNewsDetails from "../components/LandingPages/IssuerNewsDetails";
import NewsDetails from "../components/LandingPagesRedesign/NewsDetailsRedesign";
import MarketInsights from "../components/LandingPagesRedesign/MarketInsightsRedesign";
import CallMoneyChartPage from "../components/LandingPagesRedesign/CallMoneyChartPage";
import YieldAllDataTable from "../components/LandingPages/RiskBasedPricing";
import Announcements from "../components/LandingPages/Announcements";
import InstrumentDetails from "../components/LandingPages/InstrumentDetails";
import RiskBasedPricing from "../components/LandingPages/RiskBasedPricing";
import PromoterShareholdingsTable from "../components/LandingPages/PromoterShareholdingsTable";
import FixedDepositPage from "../components/LandingPages/FixedDepositPage";
import BorrowingDetails from "../components/LandingPages/BorrowingDetails";
import YieldCalculator from "../components/LandingPages/YieldCalculator";
import BondCashFlowPage from "../components/LandingPages/BondCashFlowPage";
import ConstructPortfolioPage from "../components/LandingPages/Portfolio/ConstructPortfolioPage";
import MyPortfolioDashboardPage from "../components/LandingPages/Portfolio/MyPortfolioDashboardPage";
import PrincipalProtectionPage from "../components/LandingPages/Portfolio/PrincipalProtectionPage";
import RegularIncomePage from "../components/LandingPages/Portfolio/RegularIncomePage";
import TargetReturnPage from "../components/LandingPages/Portfolio/TargetReturnPage";
import HighReturnPage from "../components/LandingPages/Portfolio/HighReturnPage";
import LiquidityPage from "../components/LandingPages/Portfolio/LiquidityPage";
import ModifiedRiskPage from "../components/LandingPages/Portfolio/ModifiedRiskPage";
import FixedIncomePortfolioBuilderPage from "../components/LandingPages/Portfolio/FixedIncomePortfolioBuilderPage";
import ImportInvestmentsPage from "../components/LandingPages/Portfolio/ImportInvestmentsPage";
import DebtTradingPlatformPage from "../components/LandingPages/Trading/DebtTradingPlatformPage";
import LandingDashboardPage from "../components/LandingPagesRedesign/LandingDashboardPage";
import LandingProfilePage from "../components/LandingPagesRedesign/LandingProfilePage";
import ExternalLandingRoute from "../components/ConditionalRoutes/ExternalLandingRoute";
import FiIntelligenceChatWidget from "../components/LandingPages/AgenticRag/FiIntelligenceChatWidget";

function InboxOAuthLegacyRedirect() {
  const [params] = useSearchParams();
  const q = params.toString();
  return <Navigate to={q ? `/import-investments?${q}` : '/import-investments'} replace />;
}

const Routers = (props) => (
  <>
    <Routes>
      {/* Login Route - Default Route */}
      <Route path="/" element={<LoginPage />} />
      {/* Landing Page Route - Protected with temporary login */}
      <Route path="/home" element={<LandingPage />} />
      <Route path="/signup-modern" element={<TempProtectedRoute><SignUpModern /></TempProtectedRoute>} />
      <Route path="/change-password" element={<TempProtectedRoute><ChangePassword /></TempProtectedRoute>} />
      <Route path="/2fa-login" element={<TempProtectedRoute><TwoFactorLogin /></TempProtectedRoute>} />
      <Route path="/reset-password" element={<TempProtectedRoute><ResetPassword /></TempProtectedRoute>} />
      {/* Admin Panel Routes */}
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute requiredRole="admin">
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="audit" element={<UnifiedAuditLogs />} />
        <Route path="sector-industry-classification" element={<SectorIndustryClassificationManagement />} />
        {/* <Route path="shareholding-pattern" element={<ShareholdingPatternManagement />} /> */}
        <Route path="issuer-esg-ratings" element={<IssuerEsgRatingsManagement />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="users/add" element={<AddUser />} />
        <Route path="users/edit/:userId" element={<EditUser />} />
        <Route path="roles" element={<AdminRoles />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="logs" element={<AdminLogs />} />
        <Route path="approval" element={<AdminApprovalComponent />} />
        <Route path="approval/news" element={<NewsApproval />} />
        <Route path="issuer-list" element={<IssuerList />} />
        <Route path="issuer/details" element={<IssuerDetails />} />
        <Route path="issuer/isins" element={<IssuerISINs />} />
        <Route path="isin/details" element={<ISINDetails />} />
        <Route path="isin-list" element={<IssuerISINs />} />
        <Route path="issuer/ratings" element={<IssuerRatings />} />

        <Route path="issuer/:cin/news" element={<IssuerNews />} />
        <Route path="profile" element={<Profile />} />
        <Route path="2fa" element={<TwoFactorAuth />} />
        <Route path="financial-details" element={<ConditionalFinancialDetailsRoute />} />

        <Route path="nsdl" element={<NSDLHome />} />
        <Route path="nsdl/6" element={<CertificatesOfDeposit />} />

        <Route path="nsdl/1" element={<CorporateInventory />} />
        <Route path="nsdl/2" element={<CommercialPapersInventory />} />
        <Route path="nsdl/3" element={<PreferenceShares />} />
        <Route path="nsdl/4" element={<DefaultedInRedemption />} />
        <Route path="nsdl/5" element={<Sec />} />

        {/* Payment and Subscription Management */}
        <Route path="payments" element={<AdminPayments />} />
        <Route path="orders" element={<AdminOrders />} />
        <Route path="subscriptions" element={<AdminSubscriptions />} />
        <Route path="plans" element={<AdminPlans />} />

        {/* Bots Section Routes */}
        <Route path="data-fetching" element={<DataFetching />} />
        <Route path="news-management" element={<NewsManagement />} />
        <Route path="market-data" element={<MarketData />} />
        <Route path="financial-data" element={<FinancialData />} />
        <Route path="government-nsdl" element={<GovernmentNSDL />} />
        <Route path="scan-data" element={<SCANData />} />
        <Route path="issuer-financial-reports" element={<IssuerFinancialReportsAdmin />} />
        <Route path="issuer-borrowing" element={<IssuerBorrowingAdmin />} />
        <Route path="manage-cashflows" element={<BondCashflowAdmin />} />
        <Route path="manage-termsheets" element={<TermsheetAdmin />} />
        <Route path="manage-termsheets/edit/:isin" element={<TermsheetEditAdmin />} />
        <Route path="credit-risk" element={<CreditRisk />} />
      </Route>

      <Route path="/login" element={<ModernLogin />} />
      <Route path="/verify-otp" element={<TempProtectedRoute><VerifyOTP /></TempProtectedRoute>} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* External user landing routes */}
      <Route
        path="/dashboard"
        element={
          <ExternalLandingRoute>
            <LandingDashboardPage />
          </ExternalLandingRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ExternalLandingRoute>
            <LandingProfilePage />
          </ExternalLandingRoute>
        }
      />

      {/* New Landing Pages - Protected with temporary login */}
      <Route path="/landing-home" element={<TempProtectedRoute><HomePage /></TempProtectedRoute>} />
      <Route path="/market-insights" element={<TempProtectedRoute><MarketInsights /></TempProtectedRoute>} />
      <Route path="/call-money" element={<TempProtectedRoute><CallMoneyChartPage /></TempProtectedRoute>} />
      <Route path="/risk-based-pricing" element={<TempProtectedRoute><RiskBasedPricing /></TempProtectedRoute>} />
      <Route path="/promoter-scores" element={<TempProtectedRoute><PromoterShareholdingsTable /></TempProtectedRoute>} />
      <Route path="/fixed-deposits" element={<TempProtectedRoute><FixedDepositPage /></TempProtectedRoute>} />
      <Route path="/fixed-deposits/:companyName" element={<TempProtectedRoute><FixedDepositPage /></TempProtectedRoute>} />
      <Route path="/announcements" element={<TempProtectedRoute><Announcements /></TempProtectedRoute>} />
      <Route path="/bond-categories" element={<TempProtectedRoute><IssuerCategory /></TempProtectedRoute>} />
      <Route path="/issuer-categorization" element={<TempProtectedRoute><IssuerCategorization /></TempProtectedRoute>} />
      <Route path="/isin-details" element={<TempProtectedRoute><InstrumentDetails /></TempProtectedRoute>} />
      <Route path="/isin-details/:isin" element={<TempProtectedRoute><InstrumentDetails /></TempProtectedRoute>} />
      <Route path="/issuers" element={<TempProtectedRoute><Issuers /></TempProtectedRoute>} />
      <Route path="/issuer-details/:issuerId" element={<TempProtectedRoute><ExternalIssuerDetails /></TempProtectedRoute>} />
      <Route path="/issuer-ratings/:issuerName" element={<TempProtectedRoute><IssuerRatingsDetails /></TempProtectedRoute>} />
      <Route path="/issuer-news/:issuerName" element={<TempProtectedRoute><IssuerNewsDetails /></TempProtectedRoute>} />
      <Route path="/news-details/:issuerName/:newsId" element={<TempProtectedRoute><NewsDetails /></TempProtectedRoute>} />
      <Route path="/borrowing-details/:issuerName" element={<TempProtectedRoute><BorrowingDetails /></TempProtectedRoute>} />
      <Route path="/financial-details" element={<TempProtectedRoute><ConditionalFinancialDetailsRoute /></TempProtectedRoute>} />
      <Route path="/issuer-financials" element={<TempProtectedRoute><IssuerFinancialsPage /></TempProtectedRoute>} />
      <Route path="/isins" element={<TempProtectedRoute><LandingInstruments /></TempProtectedRoute>} />
      <Route path="/pricing" element={<TempProtectedRoute><PricingPage /></TempProtectedRoute>} />
      <Route path="/yield-calculator" element={<TempProtectedRoute><YieldCalculator /></TempProtectedRoute>} />
      <Route path="/watchlist" element={<Navigate to="/isins?view=watchlist" replace />} />
      <Route path="/bond-cash-flow" element={<TempProtectedRoute><BondCashFlowPage /></TempProtectedRoute>} />
      <Route path="/bond-cash-flow/:isin" element={<TempProtectedRoute><BondCashFlowPage /></TempProtectedRoute>} />
      <Route path="/construct-portfolio" element={<TempProtectedRoute><ConstructPortfolioPage /></TempProtectedRoute>} />
      <Route path="/import-investments" element={<TempProtectedRoute><ImportInvestmentsPage /></TempProtectedRoute>} />
      <Route path="/inbox/oauth-callback" element={<InboxOAuthLegacyRedirect />} />
      <Route path="/my-portfolio" element={<TempProtectedRoute><MyPortfolioDashboardPage /></TempProtectedRoute>} />
      <Route path="/fixed-income-portfolio" element={<TempProtectedRoute><FixedIncomePortfolioBuilderPage /></TempProtectedRoute>} />
      <Route path="/debt-trading" element={<TempProtectedRoute><DebtTradingPlatformPage /></TempProtectedRoute>} />

      {/* Individual strategy portfolio pages */}
      <Route path="/construct-portfolio/principal-protection" element={<TempProtectedRoute><PrincipalProtectionPage /></TempProtectedRoute>} />
      <Route path="/construct-portfolio/regular-income" element={<TempProtectedRoute><RegularIncomePage /></TempProtectedRoute>} />
      <Route path="/construct-portfolio/target-return" element={<TempProtectedRoute><TargetReturnPage /></TempProtectedRoute>} />
      <Route path="/construct-portfolio/high-return" element={<TempProtectedRoute><HighReturnPage /></TempProtectedRoute>} />
      <Route path="/construct-portfolio/liquidity" element={<TempProtectedRoute><LiquidityPage /></TempProtectedRoute>} />
      <Route path="/construct-portfolio/modified-risk" element={<TempProtectedRoute><ModifiedRiskPage /></TempProtectedRoute>} />

      {/* wildcard route */}


      {/* Protected Dashboard Routes */}
      <Route
        path="/d/*"
        element={
          <ProtectedRoute forbiddenRole="admin">
            <App />
          </ProtectedRoute>
        }
      >
        <Route path="" element={<ConditionalDashboard />} />
        <Route path="2fa" element={<TwoFactorAuth />} />
        <Route path="news" element={<News />} />
        <Route path="dash" element={<ConditionalDashboard />} />
        <Route path="gov" element={<GovernmentSchemesDashboard />} />
        {/* <Route path="gov/1" element={<RBISavingBonds />} /> */}
        {/* <Route path="gov/1" element={<CCILInventory />} /> */}

        <Route path="gov/2" element={<RBIStateGovSecurities />} />
        <Route path="gov/3" element={<RBIGovSecurities />} />
        <Route path="gov/4" element={<GovSecYeild />} />
        <Route path="gov/5" element={<GovStateSecYeild />} />
        <Route path="gov/6" element={<CorporateYeild />} />

        <Route path="nsdl" element={<NSDLHome />} />
        <Route path="nsdl/6" element={<CertificatesOfDeposit />} />

        <Route path="nsdl/1" element={<CorporateInventory />} />
        <Route path="nsdl/2" element={<CommercialPapersInventory />} />
        <Route path="nsdl/3" element={<PreferenceShares />} />
        <Route path="nsdl/4" element={<DefaultedInRedemption />} />
        <Route path="nsdl/5" element={<Sec />} />
        <Route path="pricing" element={<PricingPage skipLayout={true} />} />
        <Route path="issuer-list" element={<ConditionalIssuerRoute />} />
        <Route path="issuer/details" element={<ConditionalIssuerDetailsRoute />} />
        <Route path="issuer/isins" element={<IssuerISINs />} />
        <Route path="isin/details" element={<ISINDetails />} />
        <Route path="isin-list" element={<ConditionalInstrumentsRoute />} />
        <Route path="isin-details/:isin" element={<ConditionalInstrumentDetailsRoute />} />
        <Route path="issuer/ratings" element={<IssuerRatings />} />

        <Route path="financial-details" element={<ConditionalFinancialDetailsRoute />} />
        <Route path="issuer/:issuerName/news" element={<IssuerNews />} />
        <Route path="profile" element={<Profile />} />
        <Route path="issuer-financial-reports" element={<IssuerFinancialReportsAdmin />} />

        <Route path="*" element={<ConditionalDashboard />} />
      </Route>

    </Routes>
    <FiIntelligenceChatWidget />
  </>
);

export default Routers;
